module.exports = __webpack_public_path__ + "static/media/screenshot-2@3x.b10e7c7e.png";